import { IconButton } from "@mui/joy";
import FaceRetouchingNaturalIcon from "@mui/icons-material/FaceRetouchingNatural";
import { MouseEventHandler } from "react";

export interface AIChatToggleProps {
  onClick?: MouseEventHandler<HTMLAnchorElement>;
}

export function AIIcon() {
  return (
    <FaceRetouchingNaturalIcon
      sx={{
        display: "flex",
        color: "white",
        fontSize: 22,
      }}
    />
  );
}

export default function AIChatToggle({ onClick }: AIChatToggleProps) {
  return (
    <IconButton
      onClick={onClick}
      variant="outlined"
      sx={{
        mb: 1,
        borderColor: "primary.400",
        color: "primary.500",
        gap: 1,
        background: "rgba(0, 0, 0, 0.6)",
        backdropFilter: "blur(6px)",
        transition: "all 0.3s ease-in-out",
        boxShadow: "0 0 5px rgba(0, 200, 255, 0.4)",
        "&:hover": {
          background:
            "linear-gradient(90deg, rgba(0,200,255,0.2), rgba(0,150,255,0.2))",
          boxShadow: "0 0 18px rgba(0, 200, 255, 0.8)",
          borderColor: "primary.500",
        },
        animation: "pulseGlow 2.5s infinite ease-in-out",
        "@keyframes pulseGlow": {
          "0%": { boxShadow: "0 0 3px rgba(0,200,255,0.3)" },
          "50%": { boxShadow: "0 0 8px rgba(0,200,255,0.8)" },
          "100%": { boxShadow: "0 0 3px rgba(0,200,255,0.3)" },
        },
      }}
    >
      <AIIcon />
    </IconButton>
  );
}
